import { types } from 'mobx-state-tree';

import InquiryTypeValues from '../definitions/InquiryTypeValues';


export default types.enumeration('InquiryType', Object.values(InquiryTypeValues));
